import request from '@/axios'

export interface PersonalizedConfigurationDto {
  id?: number
  /** 系统名称 */
  systemName?: string
  /** 备案号 */
  recordNumber?: string
  /** 登录页标志（minio key） */
  landingPageFlag?: string
  /** 登录页标志url（路径，直接展示用） */
  landingPageFlagUrl?: string
  /** 登录页侧面图（minio key） */
  landingPageSide?: string
  /** 登录页侧面图url（路径，直接展示用） */
  landingPageSideUrl?: string
  /** 功能页标志（minio key） */
  functionPageFlag?: string
  /** 功能页标志url（路径，直接展示用） */
  functionPageFlagUrl?: string
  /** 后端生成的临时链接，前端忽略 */
  functionPageFlagTempUrl?: string
  landingPageFlagTempUrl?: string
  landingPageSideTempUrl?: string
  /** 版权与版本信息，后端字段 version_number，前端传驼峰 versionNumber */
  versionNumber?: string
}

// 获取个性化配置详情
export const getConfigPersonalizedInfo = () => {
  return request.get({ url: '/personalized-configuration/get' })
}

// 新增-修改个性化配置
export const saveConfigPersonalized = (data: PersonalizedConfigurationDto) => {
  return request.post({ url: '/personalized-configuration/save', data })
}
